<div class="search">
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
  <input type="search" [(ngModel)]="query" placeholder="Search for participants" aria-label="Search for participants" />
</div>

<div class="list">
  <ng-container *ngIf="raised.length">
    <div class="list-head">
      <h4>Raised hands ({{ raised.length }})</h4>
    </div>
    <ul>
      <li *ngFor="let person of raised; let i = index; trackBy: trackPerson">
        <span class="order">{{ i + 1 }}</span>
        <ng-container *ngTemplateOutlet="avatarTpl; context: { $implicit: person }"></ng-container>
        <span class="name">{{ nameOf(person) }}<em *ngIf="person.local"> (You)</em></span>
        <span class="hand" aria-label="Hand raised">✋</span>
      </li>
    </ul>
  </ng-container>

  <div class="list-head">
    <h4>In this meeting ({{ people.length }})</h4>
    <button type="button" class="mute-all" *ngIf="canMute && people.length > 1" [disabled]="!othersUnmuted" (click)="muteAll.emit()">
      Mute all
    </button>
  </div>
  <ul>
    <li *ngFor="let person of filtered; trackBy: trackPerson" [class.speaking]="person.speaking">
      <ng-container *ngTemplateOutlet="avatarTpl; context: { $implicit: person }"></ng-container>
      <span class="name">
        {{ nameOf(person) }}<em *ngIf="person.local"> (You)</em>
        <small *ngIf="pinnedId === person.attendeeId">Pinned</small>
      </span>
      <span class="states">
        <span class="hand" *ngIf="person.handRaisedAt != null" aria-label="Hand raised">✋</span>
        <mat-icon
          *ngIf="person.signal != null && person.signal < 1"
          class="signal"
          fontSet="material-icons-outlined"
          [class.poor]="person.signal < 0.5"
          [matTooltip]="signalLabel(person)">signal_cellular_alt</mat-icon>
        <svg *ngIf="!hasVideo(person)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Camera off" focusable="false">
          <path d="M10.66 6H14a2 2 0 0 1 2 2v2.5l5.25-3.06a.5.5 0 0 1 .75.43v8.2" />
          <path d="M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2" />
          <path d="m2 2 20 20" />
        </svg>
        <svg *ngIf="person.muted === true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Muted" focusable="false">
          <path d="m2 2 20 20" />
          <path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2" />
          <path d="M5 10v2a7 7 0 0 0 12 5" />
          <path d="M15 9.34V5a3 3 0 0 0-5.68-1.33" />
          <path d="M9 9v3a3 3 0 0 0 5.12 2.12" />
          <path d="M12 19v3" />
        </svg>
        <svg *ngIf="person.muted === false" [class.live]="person.speaking" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Unmuted" focusable="false">
          <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
          <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
          <path d="M12 19v3" />
        </svg>
      </span>
      <button type="button" class="more" [matMenuTriggerFor]="personMenu" [attr.aria-label]="'More options for ' + nameOf(person)">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #personMenu="matMenu" class="teams-menu" xPosition="before">
        <button mat-menu-item *ngIf="!person.local && pinnedId !== person.attendeeId" (click)="pin.emit(person.attendeeId)">
          <mat-icon fontSet="material-icons-outlined">push_pin</mat-icon>
          <span>Pin for me</span>
        </button>
        <button mat-menu-item *ngIf="pinnedId === person.attendeeId" (click)="pin.emit(null)">
          <mat-icon fontSet="material-icons-outlined">push_pin</mat-icon>
          <span>Unpin</span>
        </button>
        <button mat-menu-item *ngIf="!person.local && canMute" [disabled]="person.muted === true" (click)="mute.emit(person.attendeeId)">
          <mat-icon fontSet="material-icons-outlined">mic_off</mat-icon>
          <span>Mute participant</span>
        </button>
        <button mat-menu-item *ngIf="person.local" disabled>
          <mat-icon fontSet="material-icons-outlined">person</mat-icon>
          <span>This is you</span>
        </button>
      </mat-menu>
    </li>
  </ul>
  <p class="no-match" *ngIf="query && !filtered.length">No one matches "{{ query }}"</p>
</div>

<div class="footer">
  <button type="button" class="invite" (click)="copyLink.emit()">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M19 8v6" />
      <path d="M22 11h-6" />
    </svg>
    Share invite
  </button>
</div>

<!-- A photo when the room supplies one (and it loads); initials on the person's colour otherwise. -->
<ng-template #avatarTpl let-person>
  <span class="avatar" [style.background]="color(person).background" [style.color]="color(person).color" aria-hidden="true">
    <img *ngIf="photoOf(person) as photo; else initialsText" [src]="photo" alt="" (error)="photoFailed(photo)" />
    <ng-template #initialsText>{{ initials(person) }}</ng-template>
  </span>
</ng-template>
